import styled from 'styled-components';
import { FilePdf } from '@styled-icons/fa-solid';

const theme = {
  green: '#006838',
  greenDark: '#00522d',
  yellow: '#FFD200',
  ink: '#1c1c1c',
  neutral50: '#fafafa',
  neutral100: '#f5f5f5',
  neutral300: '#d4d4d4',
  neutral400: '#a3a3a3',
  neutral600: '#525252',
  neutral700: '#404040',
  neutral900: '#171717',
};

export const PageContainer = styled.div`
  background-color: ${theme.neutral50};
  color: ${theme.neutral900};
  min-height: 100vh;
`;

export const MaxWidthContainer = styled.div`
  max-width: 1152px; /* Correspondente a max-w-6xl */
  margin: 0 auto;
  padding: 0 1.5rem; /* px-6 */
`;

// --- Hero Section ---
export const HeroSection = styled.section`
  position: relative;
  overflow: hidden;
  padding: 4rem 0;
  
  @media (min-width: 768px) {
    padding: 6rem 0;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom right, rgba(0, 104, 56, 0.2), rgba(255, 210, 0, 0.1), transparent);
  }
`;

export const HeroGrid = styled.div`
  position: relative;
  display: grid;
  gap: 2rem;
  align-items: center;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const HeroContent = styled.div`
  h1 {
    margin-top: 1rem;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.2;
    color: ${theme.ink};

    @media (min-width: 768px) {
      font-size: 3rem;
    }
  }

  p {
    margin-top: 1rem;
    font-size: 1rem;
    color: ${theme.neutral700};
    @media (min-width: 768px) {
      font-size: 1.125rem;
    }
  }
`;

export const Tag = styled.span`
  display: inline-block;
  background-color: rgba(0, 104, 56, 0.1);
  color: ${theme.green};
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
`;

export const ButtonGroup = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export const PrimaryButton = styled.a`
  display: inline-block;
  background-color: ${theme.green};
  color: white;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  border-radius: 1rem;
  text-decoration: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: ${theme.greenDark};
  }
`;

export const PillarCard = styled.div`
  border: 1px solid #e5e7eb;
  background-color: white;
  padding: 1.5rem;
  border-radius: 1.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  
  h3 {
    font-size: 1.125rem;
    font-weight: 600;
  }

  ul {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    list-style: none;
    padding: 0;
  }
`;

export const PillarItem = styled.li`
  border: 1px solid #e5e7eb;
  padding: 0.75rem;
  border-radius: 1rem;
  
  p:first-child {
    font-weight: 500;
    color: ${theme.green};
  }

  p:last-child {
    font-size: 0.875rem;
    color: ${theme.neutral600};
  }
`;

// --- NOVO --- Estilo para a caixa de contato
export const ContactInfoBox = styled.div`
    margin-top: 1rem;
    border-radius: 0.75rem;
    background-color: ${theme.neutral100};
    padding: 0.75rem;
    font-size: 0.75rem;
    color: ${theme.neutral600};
`;

export const ContactLink = styled.a`
    text-decoration: underline;
    color: ${theme.green};
    font-weight: 500;
`;

// --- Summary Section ---
export const SummarySection = styled(MaxWidthContainer)`
  padding-bottom: 1rem;
`;

export const SummaryCard = styled.div`
  border: 1px solid #e5e7eb;
  background-color: white;
  padding: 1.5rem;
  border-radius: 1.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
  }
`;

export const NavGrid = styled.nav`
  margin-top: 1rem;
  display: grid;
  gap: 0.5rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const NavItem = styled.a`
  border: 1px solid #e5e7eb;
  padding: 0.75rem;
  border-radius: 0.75rem;
  text-decoration: none;
  color: inherit;
  transition: background-color 0.2s;
  font-size: 0.875rem;

  &:hover {
    background-color: ${theme.neutral50};
  }
`;

// --- Content Section ---
export const ContentSection = styled(MaxWidthContainer)`
  padding-top: 2rem;
  padding-bottom: 3rem;
  
  @media (min-width: 768px) {
    padding-top: 3rem;
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  gap: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const Sidebar = styled.aside`
  @media (min-width: 768px) {
    position: sticky;
    top: 1rem;
    height: fit-content;
  }
`;

export const SidebarCard = styled.div`
  border: 1px solid #e5e7eb;
  background-color: white;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  font-size: 0.875rem;

  & + & {
    margin-top: 1rem;
  }
  
  p {
    color: ${theme.neutral600};
  }
  
  p:first-child {
    font-weight: 500;
    color: ${theme.neutral900};
  }

  ul {
    list-style: none;
    padding: 0;
    margin-top: 0.5rem;
    
    li {
      margin-top: 0.25rem;
    }

    li a {
      text-decoration: none;
      color: inherit;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const MainContent = styled.div`
  @media (min-width: 768px) {
    grid-column: span 2 / span 2;
  }

  section {
    scroll-margin-top: 6rem; /* Ajuste para o header fixo */
    margin-bottom: 2.5rem;

    h3 {
      font-size: 1.5rem;
      font-weight: 700;
      margin-bottom: 0.75rem;
    }
    
    h4 {
      font-size: 1.125rem;
      font-weight: 600;
      margin-bottom: 0.5rem;
      margin-top: 1rem;
    }

    p, li {
      color: ${theme.neutral700};
      line-height: 1.6;
    }

    ul {
      list-style: disc;
      padding-left: 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    hr {
      margin-top: 1.5rem;
      border-color: #e5e7eb;
    }
  }
`;

export const DocumentGrid = styled.div`
  margin-top: 1.5rem;
  display: grid;
  gap: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const DocumentCard = styled.a`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border: 1px solid #e5e7eb;
  background-color: white;
  padding: 1rem;
  border-radius: 1rem;
  text-decoration: none;
  color: ${theme.neutral900};
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &:hover {
    border-color: ${theme.green};
    background-color: ${theme.neutral50};
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  }
`;

export const PdfIcon = styled(FilePdf)`
  width: 1.25rem;
  height: 1.25rem;
  color: ${theme.green};
  flex-shrink: 0; 
`;